'use es6';

import { currentOrderedPaidProductLevels, ENTERPRISE, FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { getHubsSignupCTA } from 'pricing-pages-lib/utils/publicPageUrls';
import { BUNDLE, CRM_SUITE_ENTERPRISE, CRM_SUITE_PROFESSIONAL, CRM_SUITE_STARTER } from 'pricing-pages-lib/constants/NonMerchandiseIdProducts';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { hasPricingAndPurchasingSucceededSelector } from './LoadingStateSelectors';
import { productForSkuIdSelector, productSelector, skuSelector } from './ProductsSelectors';
/**
 * @param productLine {ProductLine}
 * @return {Object.<ProductLine, ProductName>} A map of productLevel -> apiName for the given productLine
 */

export const productNamesByProductLevelMapSelector = (state, {
  productLine
}) => currentOrderedPaidProductLevels.map(productLevel => {
  const product = productSelector(state, {
    productLine,
    productLevel
  });
  if (!product) return null;
  return product;
}).filter(product => product).reduce((acc, {
  apiName,
  productLevel
}) => Object.assign({}, acc, {
  [productLevel]: apiName
}), {});
/**
 *
 * @param state
 * @param {number} skuId
 * @param {string} [nonMerchandiseIdProduct]
 * @param {string} ctaType
 * @param {string} sourceId
 * @return {string|null}
 */

export const hubsSignupCTASelector = (state, {
  skuId,
  nonMerchandiseIdProduct,
  ctaType,
  sourceId
}) => {
  if (!hasPricingAndPurchasingSucceededSelector(state) && !nonMerchandiseIdProduct) return null;
  const {
    productLine,
    productLevel,
    apiName
  } = skuId ? productForSkuIdSelector(state, {
    skuId
  }) : {};
  return getHubsSignupCTA({
    ctaType,
    sourceId,
    nonMerchandiseIdProduct,
    productLine,
    productLevel,
    apiName
  });
}; // hubs_signup-url is added as a query param to any CTAs on the public pricing page  for the the marketing
// team's GA  tracking. New CTAs can be added just in a manner consistent to other ones, but we should be
// mindful of editing existing ones as it could break tracking and we should consult with web strategy first

export const hubsSignupUrlSelector = (state, {
  skuId,
  nonMerchandiseIdProduct,
  baseUrl
}) => {
  baseUrl = baseUrl || `${window.location.hostname}${window.location.pathname}`; // Strip query params from this URL

  let url = encodeURI(baseUrl.split('?')[0]);

  if (skuId) {
    const {
      productLevel
    } = productForSkuIdSelector(state, {
      skuId
    });
    const editionToAppend = [FREE, STARTER, PROFESSIONAL, ENTERPRISE].indexOf(productLevel) > -1 ? productLevel.toLowerCase() : undefined;

    if (editionToAppend) {
      url = `${url}/${editionToAppend}`;
    }
  } else if (nonMerchandiseIdProduct) {
    const nonMerchProductToProductLevel = {
      [CRM_SUITE_STARTER]: STARTER,
      [CRM_SUITE_PROFESSIONAL]: PROFESSIONAL,
      [CRM_SUITE_ENTERPRISE]: ENTERPRISE
    };
    const productLevel = nonMerchProductToProductLevel[nonMerchandiseIdProduct];
    const edition = productLevel ? productLevel.toLowerCase() : '';

    if (edition && url.endsWith('suite')) {
      url = `${url}/${edition}`;
    }

    if (nonMerchandiseIdProduct === BUNDLE) {
      // Pass whole url (including query params) for bundles
      url = encodeURI(baseUrl);
    }
  }

  return url;
};
export const trackingProductNameSelector = (state, {
  skuId
}) => {
  const sku = skuSelector(state, {
    skuId
  });

  if (sku.skuType === QUANTITY_PACK) {
    return sku.parcelName;
  }

  return productForSkuIdSelector(state, {
    skuId
  }).apiName;
};